/* eslint-disable */
export default {
  _Bckg_1: 'Bckg_1',
  _Title_Screen_Background: 'Title Screen/Background',
  _Title_Screen_Cake: 'Title Screen/Cake',
  _Title_Screen_Shadow: 'Title Screen/Shadow',
  _Title_Screen_PlayBlln: 'Title Screen/PlayBlln',
  _Patterns_Pttrn_4: 'Patterns/Pttrn_4',
  _Candles_Cndl_8: 'Candles/Cndl_8',
  _Flowers_Flwr_19: 'Flowers/Flwr_19',
  _Toppings_Dcr_7: 'Toppings/Dcr_7',
  _Letters_I_Black: 'Letters/I_Black',
  _Letters_I_Blue: 'Letters/I_Blue',
  _Patterns_Pttrn_8: 'Patterns/Pttrn_8',
  _Numbers___Letters_Color_text: 'Numbers & Letters/Color_text',
  _Candles_Candle_flame: 'Candles/Candle_flame',
  _Paint_Size_1: 'Paint/Size_1',
  _UI___General_Plate: 'UI _ General/Plate',
  _UI___General_Tab_Pullout: 'UI _ General/Tab_Pullout',
  _Candles_Cndl_4: 'Candles/Cndl_4',
  _Candles_Cndl_3: 'Candles/Cndl_3',
  _Paint_Size_2: 'Paint/Size_2',
  _UI___General_Countertop: 'UI _ General/Countertop',
  _Icing_Icing_1: 'Icing/Icing_1',
  _Text_Name_Bday: 'Text_Name_Bday',
  _UI___General_MCake: 'UI _ General/MCake',
  _Title_Screen_Title_Cake: 'Title Screen/Title_Cake',
  _Title_Screen_Balloon_String_Purple: 'Title Screen/Balloon_String_Purple',
  _Toppings_Dcr_3: 'Toppings/Dcr_3',
  _Title_Screen_Flame: 'Title Screen/Flame',
  _Toppings_Dcr_6: 'Toppings/Dcr_6',
  _Candles_Cndl_6: 'Candles/Cndl_6',
  _Numbers_8_Black: 'Numbers/8_Black',
  _Candles_Cndl_7: 'Candles/Cndl_7',
  _Paint_Size_3: 'Paint/Size_3',
  _Candles_Cndl_1: 'Candles/Cndl_1',
  _UI___General_Asset_184: 'UI _ General/Asset 184',
  _Menus_Popups_Menu_Popup: 'Menus_Popups/Menu_Popup',
  _Candles_Cndl_Fire_8: 'Candles/Cndl_Fire_8',
  _Title_Screen_Title_Candle: 'Title Screen/Title_Candle',
  _Icing_Icing_4: 'Icing/Icing_4',
  _Candles_Cndl_2: 'Candles/Cndl_2',
  _Patterns_Pttrn_3: 'Patterns/Pttrn_3',
  _Numbers_8_Blue: 'Numbers/8_Blue',
  _Patterns_Pttrn_2: 'Patterns/Pttrn_2',
  _Toppings_Dcr_14: 'Toppings/Dcr_14',
  _Paint_Size_Txt: 'Paint/Size_Txt',
  _Paint_Size_4: 'Paint/Size_4',
  _Numbers_1_Red: 'Numbers/1_Red',
  _Candles_Cndl_Fire_3: 'Candles/Cndl_Fire_3',
  _Icing_Icing_3: 'Icing/Icing_3',
  _Candles_Candle_bigflame: 'Candles/Candle_bigflame',
  _Icing_Icing_2: 'Icing/Icing_2',
  _Title_Screen_Cake_A: 'Title Screen/Cake_A',
  _Title_Screen_Cake_C: 'Title Screen/Cake_C',
  _Toppings_Dcr_16: 'Toppings/Dcr_16',
  _Cake_Color_Instruction: 'Cake Color/Instruction',
  _Toppings_Dcr_11: 'Toppings/Dcr_11',
  _Patterns_Pttrn_5: 'Patterns/Pttrn_5',
  _Title_Screen_Cake_E: 'Title Screen/Cake_E',
  _Patterns_Pttrn_1: 'Patterns/Pttrn_1',
  _Patterns_Pttrn_7: 'Patterns/Pttrn_7',
  _Cake_Color_Next: 'Cake Color/Next',
  _Numbers___Letters_Color_Black: 'Numbers & Letters/Color_Black',
  _Numbers_1_Black: 'Numbers/1_Black',
  _Title_Screen_Cake_K: 'Title Screen/Cake_K',
  _Candles_Cndl_5: 'Candles/Cndl_5',
  _Menus_Popups_X: 'Menus_Popups/X',
  _Toppings_Dcr_15: 'Toppings/Dcr_15',
  _Candles_Cndl_Fire_2: 'Candles/Cndl_Fire_2',
  _Candles_Cndl_Fire_4: 'Candles/Cndl_Fire_4',
  _Patterns_Pttrn_6: 'Patterns/Pttrn_6',
  _Btn_Done: 'Btn_Done',
  _Toppings_Dcr_1: 'Toppings/Dcr_1',
  _Letters_Exclamation_Black: 'Letters/Exclamation_Black',
  _Numbers___Letters_Color_Green: 'Numbers & Letters/Color_Green',
  _Numbers___Letters_Color_Red: 'Numbers & Letters/Color_Red',
  _Numbers___Letters_Color_Orange: 'Numbers & Letters/Color_Orange',
  _Numbers___Letters_Color_Blue: 'Numbers & Letters/Color_Blue',
  _Numbers___Letters_Color_Purple: 'Numbers & Letters/Color_Purple',
  _Paint_Size_5: 'Paint/Size_5',
  _Letters_Exclamation_Blue: 'Letters/Exclamation_Blue',
  _Letters_Exclamation_Green: 'Letters/Exclamation_Green',
  _Letters_Exclamation_Orange: 'Letters/Exclamation_Orange',
  _Letters_Exclamation_Purple: 'Letters/Exclamation_Purple',
  _Letters_Exclamation_Red: 'Letters/Exclamation_Red',
  _Letters_I_Green: 'Letters/I_Green',
  _Letters_I_Orange: 'Letters/I_Orange',
  _Letters_I_Purple: 'Letters/I_Purple',
  _Letters_I_Red: 'Letters/I_Red',
  _Menus_Popups_Restart: 'Menus_Popups/Restart',
  _Icing_Icing_5: 'Icing/Icing_5',
  _Icing_Icing_6: 'Icing/Icing_6',
  _Title_Screen_Text_Make_A: 'Title Screen/Text_Make_A',
  _Icing_Icing_7: 'Icing/Icing_7',
  _Title_Screen_Blln_2: 'Title Screen/Blln_2',
  _Title_Screen_Blln_3: 'Title Screen/Blln_3',
  _Title_Screen_Blln_1: 'Title Screen/Blln_1',
  _Title_Screen_Blln_4: 'Title Screen/Blln_4',
  _Menus_Popups_New: 'Menus_Popups/New',
  _Menus_Popups_No: 'Menus_Popups/No',
  _Menus_Popups_Print: 'Menus_Popups/Print',
  _Menus_Popups_Save: 'Menus_Popups/Save',
  _Menus_Popups_Yes: 'Menus_Popups/Yes',
  _UI___General_Tab_Candle: 'UI _ General/Tab_Candle',
  _UI___General_Tab_Icing: 'UI _ General/Tab_Icing',
  _Numbers_1_Blue: 'Numbers/1_Blue',
  _Numbers_4_Black: 'Numbers/4_Black',
  _Numbers_4_Blue: 'Numbers/4_Blue',
  _UI___General_Tab_Paint: 'UI _ General/Tab_Paint',
  _UI___General_Tab_Flower: 'UI _ General/Tab_Flower',
  _Numbers_4_Green: 'Numbers/4_Green',
  _Title_Screen_PlayBtn: 'Title Screen/PlayBtn',
  _UI___General_Tab_Decor: 'UI _ General/Tab_Decor',
  _UI___General_Tab_Letters: 'UI _ General/Tab_Letters',
  _UI___General_Tab_Numbers: 'UI _ General/Tab_Numbers',
  _UI___General_Tab_Pattern: 'UI _ General/Tab_Pattern',
  _Flowers_Flwr_17: 'Flowers/Flwr_17',
  _Flowers_Flwr_18: 'Flowers/Flwr_18',
  _Flowers_Flwr_20: 'Flowers/Flwr_20',
  _Flowers_Flwr_16: 'Flowers/Flwr_16',
  _Toppings_Dcr_10: 'Toppings/Dcr_10',
  _Flowers_Flwr_1: 'Flowers/Flwr_1',
  _Toppings_Dcr_13: 'Toppings/Dcr_13',
  _Toppings_Dcr_2: 'Toppings/Dcr_2',
  _Flowers_Flwr_2: 'Flowers/Flwr_2',
  _Numbers_1_Green: 'Numbers/1_Green',
  _Flowers_Flwr_3: 'Flowers/Flwr_3',
  _Flowers_Flwr_4: 'Flowers/Flwr_4',
  _Flowers_Flwr_5: 'Flowers/Flwr_5',
  _Flowers_Flwr_15: 'Flowers/Flwr_15',
  _Toppings_Dcr_5: 'Toppings/Dcr_5',
  _Flowers_Flwr_11: 'Flowers/Flwr_11',
  _Letters_J_Black: 'Letters/J_Black',
  _Flowers_Flwr_12: 'Flowers/Flwr_12',
  _Letters_J_Green: 'Letters/J_Green',
  _Flowers_Flwr_13: 'Flowers/Flwr_13',
  _Flowers_Flwr_14: 'Flowers/Flwr_14',
  _Toppings_Dcr_12: 'Toppings/Dcr_12',
  _Numbers_8_Green: 'Numbers/8_Green',
  _Toppings_Dcr_8: 'Toppings/Dcr_8',
  _Flowers_Flwr_6: 'Flowers/Flwr_6',
  _Numbers_7_Black: 'Numbers/7_Black',
  _Toppings_Dcr_4: 'Toppings/Dcr_4',
  _Letters_W_Black: 'Letters/W_Black',
  _Flowers_Flwr_7: 'Flowers/Flwr_7',
  _Letters_Q_Black: 'Letters/Q_Black',
  _Numbers_3_Black: 'Numbers/3_Black',
  _Letters_W_Green: 'Letters/W_Green',
  _Letters_W_Blue: 'Letters/W_Blue',
  _Numbers_0_Green: 'Numbers/0_Green',
  _Numbers_8_Orange: 'Numbers/8_Orange',
  _Numbers_8_Purple: 'Numbers/8_Purple',
  _Numbers_8_Red: 'Numbers/8_Red',
  _Numbers_4_Orange: 'Numbers/4_Orange',
  _Flowers_Flwr_8: 'Flowers/Flwr_8',
  _Numbers_4_Purple: 'Numbers/4_Purple',
  _Numbers_4_Red: 'Numbers/4_Red',
  _Flowers_Flwr_9: 'Flowers/Flwr_9',
  _Toppings_Dcr_9: 'Toppings/Dcr_9',
  _Numbers_9_Black: 'Numbers/9_Black',
  _Flowers_Flwr_10: 'Flowers/Flwr_10',
  _Numbers_9_Blue: 'Numbers/9_Blue',
  _Letters_W_Orange: 'Letters/W_Orange',
  _Numbers_9_Green: 'Numbers/9_Green',
  _Letters_W_Purple: 'Letters/W_Purple',
  _Cake_Color_Clr_1: 'Cake Color/Clr_1',
  _Numbers_0_Orange: 'Numbers/0_Orange',
  _Numbers_9_Orange: 'Numbers/9_Orange',
  _Numbers_9_Purple: 'Numbers/9_Purple',
  _Numbers_9_Red: 'Numbers/9_Red',
  _Numbers_3_Blue: 'Numbers/3_Blue',
  _Letters_Q_Blue: 'Letters/Q_Blue',
  _Letters_W_Red: 'Letters/W_Red',
  _Numbers_0_Purple: 'Numbers/0_Purple',
  _Letters_M_Black: 'Letters/M_Black',
  _Numbers_7_Blue: 'Numbers/7_Blue',
  _Numbers_7_Green: 'Numbers/7_Green',
  _Letters_O_Black: 'Letters/O_Black',
  _Numbers_0_Red: 'Numbers/0_Red',
  _Numbers_7_Orange: 'Numbers/7_Orange',
  _Numbers_7_Purple: 'Numbers/7_Purple',
  _Letters_M_Blue: 'Letters/M_Blue',
  _Letters_G_Black: 'Letters/G_Black',
  _Letters_M_Green: 'Letters/M_Green',
  _Numbers_7_Red: 'Numbers/7_Red',
  _Numbers_3_Orange: 'Numbers/3_Orange',
  _Numbers_3_Purple: 'Numbers/3_Purple',
  _Numbers_3_Green: 'Numbers/3_Green',
  _Numbers_3_Red: 'Numbers/3_Red',
  _Numbers_6_Black: 'Numbers/6_Black',
  _Numbers_6_Blue: 'Numbers/6_Blue',
  _Numbers_2_Black: 'Numbers/2_Black',
  _Numbers_2_Blue: 'Numbers/2_Blue',
  _Numbers_2_Green: 'Numbers/2_Green',
  _Letters_M_Orange: 'Letters/M_Orange',
  _Letters_Q_Green: 'Letters/Q_Green',
  _Numbers_2_Orange: 'Numbers/2_Orange',
  _Numbers_2_Purple: 'Numbers/2_Purple',
  _Numbers_2_Red: 'Numbers/2_Red',
  _Numbers_6_Green: 'Numbers/6_Green',
  _Numbers_6_Orange: 'Numbers/6_Orange',
  _Numbers_6_Purple: 'Numbers/6_Purple',
  _Numbers_6_Red: 'Numbers/6_Red',
  _Numbers_5_Black: 'Numbers/5_Black',
  _Letters_M_Purple: 'Letters/M_Purple',
  _Menus_Popups_Btn_SoundOff: 'Menus_Popups/Btn_SoundOff',
  _Letters_M_Red: 'Letters/M_Red',
  _Cake_Color_Clr_2: 'Cake Color/Clr_2',
  _Numbers_0_Black: 'Numbers/0_Black',
  _Numbers_0_Blue: 'Numbers/0_Blue',
  _Letters_Q_Orange: 'Letters/Q_Orange',
  _Letters_Q_Purple: 'Letters/Q_Purple',
  _Numbers_5_Blue: 'Numbers/5_Blue',
  _Letters_Q_Red: 'Letters/Q_Red',
  _Cake_Color_Clr_3: 'Cake Color/Clr_3',
  _Menus_Popups_Btn_SoundOn: 'Menus_Popups/Btn_SoundOn',
  _Numbers_5_Green: 'Numbers/5_Green',
  _Cake_Color_Clr_4: 'Cake Color/Clr_4',
  _Menus_Popups_Btn_Undo: 'Menus_Popups/Btn_Undo',
  _Letters_G_Green: 'Letters/G_Green',
  _Numbers_5_Orange: 'Numbers/5_Orange',
  _Numbers_5_Purple: 'Numbers/5_Purple',
  _Numbers_5_Red: 'Numbers/5_Red',
  _Letters_G_Blue: 'Letters/G_Blue',
  _Letters_G_Orange: 'Letters/G_Orange',
  _Menus_Popups_Btn_Start_Over: 'Menus_Popups/Btn_Start_Over',
  _Numbers_1_Orange: 'Numbers/1_Orange',
  _Numbers_1_Purple: 'Numbers/1_Purple',
  _Letters_G_Purple: 'Letters/G_Purple',
  _Letters_O_Blue: 'Letters/O_Blue',
  _Letters_G_Red: 'Letters/G_Red',
  _Letters_A_Blue: 'Letters/A_Blue',
  _Letters_O_Green: 'Letters/O_Green',
  _Letters_O_Orange: 'Letters/O_Orange',
  _Letters_O_Red: 'Letters/O_Red',
  _Letters_A_Orange: 'Letters/A_Orange',
  _Letters_A_Purple: 'Letters/A_Purple',
  _Letters_A_Red: 'Letters/A_Red',
  _Cake_Color_Clr_5: 'Cake Color/Clr_5',
  _Cake_Color_Clr_6: 'Cake Color/Clr_6',
  _Letters_A_Black: 'Letters/A_Black',
  _Cake_Color_Clr_7: 'Cake Color/Clr_7',
  _Cake_Color_Clr_8: 'Cake Color/Clr_8',
  _Cake_Color_Clr_9: 'Cake Color/Clr_9',
  _Cake_Color_Clr_10: 'Cake Color/Clr_10',
  _Letters_A_Green: 'Letters/A_Green',
  _Cake_Color_Clr_11: 'Cake Color/Clr_11',
  _Cake_Color_Clr_12: 'Cake Color/Clr_12',
  _Letters_R_Black: 'Letters/R_Black',
  _Letters_R_Green: 'Letters/R_Green',
  _Letters_R_Red: 'Letters/R_Red',
  _Cake_Color_Clr_13: 'Cake Color/Clr_13',
  _Letters_U_Black: 'Letters/U_Black',
  _Letters_U_Green: 'Letters/U_Green',
  _Letters_U_Red: 'Letters/U_Red',
  _Cake_Color_Clr_14: 'Cake Color/Clr_14',
  _Cake_Color_Clr_15: 'Cake Color/Clr_15',
  _Cake_Color_Clr_16: 'Cake Color/Clr_16',
  _Letters_R_Blue: 'Letters/R_Blue',
  _Letters_C_Black: 'Letters/C_Black',
  _Letters_R_Orange: 'Letters/R_Orange',
  _Letters_R_Purple: 'Letters/R_Purple',
  _Letters_U_Blue: 'Letters/U_Blue',
  _Letters_U_Orange: 'Letters/U_Orange',
  _Letters_O_Purple: 'Letters/O_Purple',
  _Letters_C_Blue: 'Letters/C_Blue',
  _Letters_C_Green: 'Letters/C_Green',
  _Menus_Popups_Btn_Home: 'Menus_Popups/Btn_Home',
  _Letters_U_Purple: 'Letters/U_Purple',
  _Letters_C_Orange: 'Letters/C_Orange',
  _Letters_C_Purple: 'Letters/C_Purple',
  _Letters_C_Red: 'Letters/C_Red',
  _Cake_Color_Clr_17: 'Cake Color/Clr_17',
  _Letters_D_Black: 'Letters/D_Black',
  _Cake_Color_Clr_18: 'Cake Color/Clr_18',
  _Letters_D_Blue: 'Letters/D_Blue',
  _Letters_D_Green: 'Letters/D_Green',
  _Letters_D_Orange: 'Letters/D_Orange',
  _Letters_D_Purple: 'Letters/D_Purple',
  _Cake_Color_Clr_19: 'Cake Color/Clr_19',
  _Cake_Color_Clr_20: 'Cake Color/Clr_20',
  _Letters_J_Purple: 'Letters/J_Purple',
  _Candles_Cndl_Fire_1: 'Candles/Cndl_Fire_1',
  _Candles_Cndl_Fire_6: 'Candles/Cndl_Fire_6',
  _Letters_V_Black: 'Letters/V_Black',
  _Letters_D_Red: 'Letters/D_Red',
  _Letters_N_Black: 'Letters/N_Black',
  _Letters_N_Green: 'Letters/N_Green',
  _Letters_N_Blue: 'Letters/N_Blue',
  _Letters_V_Green: 'Letters/V_Green',
  _Letters_X_Black: 'Letters/X_Black',
  _Letters_X_Blue: 'Letters/X_Blue',
  _Letters_X_Green: 'Letters/X_Green',
  _Letters_N_Orange: 'Letters/N_Orange',
  _Letters_N_Purple: 'Letters/N_Purple',
  _Letters_X_Orange: 'Letters/X_Orange',
  _Letters_X_Purple: 'Letters/X_Purple',
  _Letters_N_Red: 'Letters/N_Red',
  _Letters_X_Red: 'Letters/X_Red',
  _Letters_Y_Black: 'Letters/Y_Black',
  _Letters_B_Black: 'Letters/B_Black',
  _Letters_L_Black: 'Letters/L_Black',
  _Letters_Y_Blue: 'Letters/Y_Blue',
  _Letters_Y_Green: 'Letters/Y_Green',
  _Letters_L_Blue: 'Letters/L_Blue',
  _Letters_B_Green: 'Letters/B_Green',
  _Letters_B_Red: 'Letters/B_Red',
  _Letters_B_Blue: 'Letters/B_Blue',
  _Letters_Y_Orange: 'Letters/Y_Orange',
  _Letters_Y_Purple: 'Letters/Y_Purple',
  _Letters_Y_Red: 'Letters/Y_Red',
  _Letters_K_Black: 'Letters/K_Black',
  _Letters_K_Green: 'Letters/K_Green',
  _Letters_V_Blue: 'Letters/V_Blue',
  _Letters_V_Orange: 'Letters/V_Orange',
  _Letters_V_Purple: 'Letters/V_Purple',
  _Letters_V_Red: 'Letters/V_Red',
  _Letters_P_Orange: 'Letters/P_Orange',
  _Letters_P_Red: 'Letters/P_Red',
  _Letters_L_Green: 'Letters/L_Green',
  _Letters_H_Black: 'Letters/H_Black',
  _Letters_H_Green: 'Letters/H_Green',
  _Letters_B_Orange: 'Letters/B_Orange',
  _Letters_B_Purple: 'Letters/B_Purple',
  _Letters_K_Blue: 'Letters/K_Blue',
  _Letters_K_Orange: 'Letters/K_Orange',
  _Letters_K_Purple: 'Letters/K_Purple',
  _Letters_K_Red: 'Letters/K_Red',
  _Letters_P_Black: 'Letters/P_Black',
  _Letters_P_Blue: 'Letters/P_Blue',
  _Letters_P_Green: 'Letters/P_Green',
  _Letters_P_Purple: 'Letters/P_Purple',
  _Letters_S_Black: 'Letters/S_Black',
  _Letters_S_Blue: 'Letters/S_Blue',
  _Letters_S_Green: 'Letters/S_Green',
  _Letters_S_Purple: 'Letters/S_Purple',
  _Letters_S_Red: 'Letters/S_Red',
  _Letters_T_Black: 'Letters/T_Black',
  _Letters_H_Blue: 'Letters/H_Blue',
  _Letters_T_Blue: 'Letters/T_Blue',
  _Letters_T_Green: 'Letters/T_Green',
  _Letters_T_Orange: 'Letters/T_Orange',
  _Letters_T_Purple: 'Letters/T_Purple',
  _Letters_T_Red: 'Letters/T_Red',
  _Letters_E_Black: 'Letters/E_Black',
  _Letters_H_Orange: 'Letters/H_Orange',
  _Letters_H_Purple: 'Letters/H_Purple',
  _Letters_E_Green: 'Letters/E_Green',
  _Letters_E_Red: 'Letters/E_Red',
  _Letters_S_Orange: 'Letters/S_Orange',
  _Letters_Z_Black: 'Letters/Z_Black',
  _Letters_Z_Green: 'Letters/Z_Green',
  _Letters_E_Blue: 'Letters/E_Blue',
  _Candles_Cndl_Fire_7: 'Candles/Cndl_Fire_7',
  _Letters_H_Red: 'Letters/H_Red',
  _Candles_Cndl_Fire_5: 'Candles/Cndl_Fire_5',
  _Letters_E_Orange: 'Letters/E_Orange',
  _Letters_E_Purple: 'Letters/E_Purple',
  _Letters_Z_Blue: 'Letters/Z_Blue',
  _Letters_Z_Orange: 'Letters/Z_Orange',
  _Letters_Z_Purple: 'Letters/Z_Purple',
  _Letters_Z_Red: 'Letters/Z_Red',
  _Letters_L_Orange: 'Letters/L_Orange',
  _Letters_L_Purple: 'Letters/L_Purple',
  _Letters_L_Red: 'Letters/L_Red',
  _Letters_F_Blue: 'Letters/F_Blue',
  _Letters_F_Orange: 'Letters/F_Orange',
  _Letters_J_Blue: 'Letters/J_Blue',
  _Letters_F_Purple: 'Letters/F_Purple',
  _Letters_F_Black: 'Letters/F_Black',
  _Letters_F_Green: 'Letters/F_Green',
  _Letters_F_Red: 'Letters/F_Red',
  _Letters_J_Orange: 'Letters/J_Orange',
  _Letters_J_Red: 'Letters/J_Red',
}